import { DEFAULT_TOAST_INDENT, RAISED_TOAST_INDENT } from '../constants';

interface IGetToastIndentParams {
  isPhone: boolean;
  isTablet: boolean;
  isPortrait: boolean;
}

/**
 * Возвращает отступ тоста от нижнего края экрана.
 * На телефоне и планшете в портретной ориентации тост иначе перекрывает кнопку «Список»
 */
export function getToastIndent({ isPhone, isTablet, isPortrait }: IGetToastIndentParams): string {
  return isPhone || (isTablet && isPortrait) ? RAISED_TOAST_INDENT : DEFAULT_TOAST_INDENT;
}
